import React, { useEffect, useState } from "react";
import AdrmController from "./AdrmController";
import axios from "axios";
import {
  getFinancialYearStart,
  getFYStartDateFormatted,
} from "../../../../../Utilitie";
import Loading from "../../../../../Extra/Loading";
import AdrmSummeryGraph from "./AdrmSummeryGraph";
const sampleState = {
  MONTH: false,
  BLOCK_DATE: false,
  DEPT: false,
  "DATA MATRIX": false,
};
const AdrmGraphMaster = ({ dates }) => {
  const urlPrefixBlock = process.env.REACT_APP_URL_BLOCK_PREFIX;

  const [loading, setLoading] = useState(false);
  const [error, setError] = useState(false);
  const [filterData, setFilteredData] = useState(null);
  const [selectedData, setSelectedData] = useState(null);
  const [dataForTable, setDataForTable] = useState(false);
  const [openStates, setOpenStates] = useState(sampleState);
  //   const [error, setError] = useState(false);
  //   const [error, setError] = useState(false);
  const [adrmDataFY, setAdrmDataFY] = useState(false);

  const fetchedData = async () => {
    setLoading(true);
    setError(false);
    try {
      const response = await axios.get(
        `${urlPrefixBlock}getADRM_CURR_PRE_YR_DATA?start=${getFinancialYearStart()}&end=${
          dates.endDate
        }`,
      );

      if (response.data.status === "ok") {
        setAdrmDataFY(response.data.data);
      }
      setLoading(false);
    } catch (error) {
      console.error("Failed to fetch stations:", error);
      setLoading(false);
      setError(true);
    }
  };
  let fromDate = getFYStartDateFormatted();
  useEffect(() => {
    fetchedData();
  }, []);
  return (
    <div
      className="papaDiv border border-dark"
      onClick={() => {
        setOpenStates(sampleState);
      }}
    >
      <h5 className="bg-dark text-white">
        {" "}
        Summary Data{" "}
        <b style={{ color: "rgba(178, 178, 178, 1)", fontSize: "15px" }}>
          ({fromDate}-{dates.endDate})
        </b>
      </h5>
      <div
        className="sticky-controller"
        style={{ zIndex: 3 }}
        onClick={(e) => {
          e.stopPropagation();
        }}
      >
        {loading && <Loading />}
        <AdrmController
          data={adrmDataFY}
          setFilteredData={setFilteredData}
          setOpenStates={setOpenStates}
          openStates={openStates}
          setSelectedData={setSelectedData}
          setDataForTable={setDataForTable}
        />
      </div>
      <AdrmSummeryGraph data={filterData} selectedData={selectedData} />
    </div>
  );
};
export default AdrmGraphMaster;
